import CheckIcon from '@dustin-web/microsite-components/src/icon/generated/check'
import CompareIcon from '@dustin-web/microsite-components/src/icon/generated/compare'
import classNames from 'classnames'
import Tooltip from '@dustin-web/microsite-components/src/tooltip'

type CompareComponentProps = {
  listForm: boolean
  itemExist?: boolean
  updateCompareList: (e: any) => void
  noText: boolean
  withBorder: boolean
  className?: string
  productInformationCompareIcon: boolean
  buttonText: string
  tooltipText: string
}
export default function CompareComponent({
  listForm,
  itemExist,
  updateCompareList,
  noText,
  withBorder,
  className,
  productInformationCompareIcon,
  buttonText,
  tooltipText,
}: CompareComponentProps) {
  if (listForm) {
    return (
      <Tooltip tooltipText={tooltipText} className={`c-compare ${className} flex-row-reverse`}>
        <button
          type="button"
          className="c-compare__btn"
          data-test-id="compare-button"
          onClick={updateCompareList}>
          <>
            {itemExist ? (
              <CheckIcon className="i-16 c-compare__icon c-compare__icon--check" />
            ) : (
              <CompareIcon className="i-16 c-compare__icon" />
            )}
            {!noText && <span className="c-compare__text">{buttonText}</span>}
          </>
        </button>
      </Tooltip>
    )
  }

  if (withBorder) {
    return (
      <button
        type="button"
        className="u-w-100"
        data-test-id="compare-button"
        onClick={updateCompareList}>
        <>
          {itemExist ? (
            <CheckIcon className="i-20 u-mr-8" />
          ) : (
            <CompareIcon name="compare" className="i-20 u-mr-8" />
          )}
          {!noText && <span>{buttonText}</span>}
        </>
      </button>
    )
  }

  return (
    <div className={`c-compare ${className}`}>
      <button
        type="button"
        className="c-compare__btn"
        data-test-id="compare-button"
        onClick={updateCompareList}>
        <>
          {itemExist ? (
            <CheckIcon
              className={classNames('i-16 c-compare__icon c-compare__icon--check', {
                'i-20': productInformationCompareIcon,
              })}
            />
          ) : (
            <CompareIcon
              className={classNames('i-16 c-compare__icon', {
                'i-20': productInformationCompareIcon,
              })}
            />
          )}
          <span
            className={classNames('c-compare__text', {
              'c-compare__product-information-text': productInformationCompareIcon,
            })}>
            {buttonText}
          </span>
        </>
      </button>
    </div>
  )
}
